import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from './routers';

// api 接口
import auth from '../api/auth';

// 全局配置文件和本地存储
import { getRouters, setRouters, setToken } from '../utils/auth';
import { isToken, setUserName } from '../utils/users';
import config from '../configs';
import notFoundCompoment from '@/views/404.vue';

Vue.use(Router);
/* Layout */
import layout from '../views/layout/Layout';

import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';// progress 样式
NProgress.configure({showSpinner: false});// NProgress配置

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: constantRouterMap,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
});

// 404路由
const notFound = [
  {
    path: '*',
    name: '404',
    hidden: true,
    component: notFoundCompoment
  }
];

let routerList = [];

/**
 * 递归组织路由表
 * @param routers
 * */
function filterAsyncAddRouter (routers) {

  let listRouters = JSON.parse(JSON.stringify(routers)) || [];
  for (let i = 0; i < listRouters.length; i++) {

    let item = listRouters[i];
    item.component = layout;
    if (item.children && item.children.length > 0) {
      for (let j = 0; j < item.children.length; j++) {

        let itemChild = item.children[j];
        let componentName = itemChild.component;
        itemChild.component = resolve => require(['@/views/' + componentName], resolve);
      }
    }
  }
  routerList = listRouters;
  return listRouters;
}

/**
 * 允许访问的URL---白名单
 * @param url
 */
function checkAlwaysAllowedUrls (url) {
  return (
    url.includes('/login')
  );
}

// 全局的 before 钩子
router.beforeEach((to, from, next) => {
  router.options.routes = getRouters();
  NProgress.start(); // 开始进度条
  /**
   * 该页面是否需要授权才可以访问
   * @returns {boolean}
   */
  function isAuth () {
    return to.matched.some(record => record.meta.requiresAuth);
  }

  // 设置页面标题title
  document.title = to.meta.title || to.name || 'Unknow title';

  const loginRoute = {
    path: '/login',
    query: {redirect: to.fullPath}
  };

  (async function () {
    // cookie 存在 并且 未登录状态
    if (to.query.cookie && !isToken()) {
      // alert(!isToken())
      try {
        let menus = await auth.getMenus({cookie: to.query.cookie});
        // console.log(menus)
        let {data} = menus.data;
        setUserName(data.username);
        setRouters(data.menus);
        setToken(data.token);// 设置token
        next('/');
        NProgress.done();
      } catch (e) {
        next(loginRoute);
      }
    } else {
      // alert('2222222');
      /**
       * 如果有token存在
       * 检查当前页面
       */
      if (isToken() && !checkAlwaysAllowedUrls(to.path)) {
        if (routerList.length === 0) { // 添加路由
          let menus = getRouters();
          let accessedRouters = filterAsyncAddRouter(menus);

          let accessedRouterMaps = accessedRouters.concat(notFound);
          router.addRoutes(accessedRouterMaps);
          next({...to, replace: true});
        }
        if (to.path === '/') {
          let menus = getRouters();
          if (!!menus) {
            // console.log(menus[0].path)
            next(menus[0].path);
          } else {
            next();
          }
        } else {
          next();
        }
      } else {
        // alert('333333', isAuth(), !isToken());
        if (to.matched.length === 0) {
          let originUrl = `${config.HOST}/&toolsId=${config.TOOLS_ID}`;
          location.replace(config.MASTER_WEB_URL + '/public-login?auth_callback=' + originUrl);
        } else {
          // 如果页面需要授权访问 并且 用户未登录， 返回登录页
          if (isAuth() && !isToken()) {
            next(loginRoute);
          } else {
            next(); // 确保一定要调用 next()
          }
        }
      }
    }
  })();

});


router.afterEach(() => {
  NProgress.done(); // 完成进度条
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js